import React, { useState, useEffect } from "react";
import {
  Tag,
  message,
  Button,
  Form,
  Input,
  Table,
  Switch,
  Space,
  Modal,
  TreeSelect,
  Radio,
  InputNumber,
  Select,
} from "antd";
const { Option } = Select;
import { ExclamationCircleOutlined } from "@ant-design/icons";
import ResourceApi from "@api/resource";
import MyIcon from "@components/MyIcon";
import { createMenu, deleteMenu, editMenu } from "@api/menu";
import DepartmentApi from "@api/department";
import "./index.scss";

const typeName = ["公司", "部门"];
const layout = {
  labelCol: {
    span: 4,
  },
  wrapperCol: {
    span: 20,
  },
};
const DepartMent = (props) => {
  const [form] = Form.useForm();
  const [editId, setEditId] = useState([]);
  const [resourceTree, setResourceTree] = useState([]);
  const [treeData, setTreeData] = useState([]);
  const [checkStrictly, setCheckStrictly] = useState(false);
  const [loading, setLoading] = useState(true);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modelModify, setModelModify] = useState("add");
  const [deptType, setDeptType] = useState(null);
  const [personModal, setPersonModal] = useState(false);
  const [deptPersonLoading, setDeptPersonLoading] = useState(false);
  const [personList, setPersonList] = useState([]);
  const [addPersonModal, setAddPersonModal] = useState(false);
  const [person, setPerson] = useState();
  const [lookPersonId, setLookPersonId] = useState();
  const [deptChildList, setDeptChildList] = useState([]);

  useEffect(() => {
    list();
    return () => {};
  }, []);

  const onFinish = (values) => {
    console.log("Success:", values);
  };
  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };
  // 递归处理数据
  const getTreeData = (data) => {
    for (var i = 0; i < data.length; i++) {
      if (data[i].children.length < 1) {
        data[i].children = null;
        data[i].title = data[i].name;
        data[i].value = data[i].id;
      } else {
        data[i].title = data[i].name;
        data[i].value = data[i].id;
        getTreeData(data[i].children);
      }
    }
    return data;
  };

  const showModel = (type, params) => {
    if (type === "add" && params) {
      form.setFieldsValue({ pid: params.id });
    }
    if (type === "edit" && params) {
      setEditId(params.id);
      setDeptType(params.type);
      form.setFieldsValue({ ...params });
    }

    setModelModify(type);
    setIsModalOpen(true);
  };

  const lookPerson = (id) => {
    setLookPersonId(id);
    getPersonList(id);
  };

  const getPersonList = (id) => {
    setDeptPersonLoading(true);
    setPersonModal(true);
    DepartmentApi.getDeptHeadersByDeptId({ deptId: id }).then((res) => {
      if (res.status !== "0") return;
      setDeptPersonLoading(false);
      setPersonList(res.data);
    });
  };

  const addDeptPerson = () => {
    if (!person) return message.error("部门负责人不能为空");
    DepartmentApi.addDeptHeader({ deptId: lookPersonId, userId: person }).then(
      (res) => {
        if (res.status !== "0") return;
        message.success("新增成功");
        setPerson("");
        setAddPersonModal(false);
        getPersonList(lookPersonId);
      }
    );
  };

  const delPerson = (deptId, userId) => {
    DepartmentApi.delDeptHeader({ deptId, userId }).then((res) => {
      if (res.status !== "0") return;
      message.success("删除成功");
      getPersonList(lookPersonId);
    });
  };

  const getDeptChildPerson = () => {
    setAddPersonModal(true);
    DepartmentApi.getUsersByDeptId({
      deptId: lookPersonId,
      containDeptHeaders: 0,
    }).then((res) => {
      if (res.status !== "0") return;
      setDeptChildList(res.data);
    });
  };

  // 处理新增或编辑的数据
  const submiteForm = () => {
    form.validateFields().then(async (values) => {
      const params = JSON.parse(JSON.stringify(values));
      params.pid = params.pid ? params.pid : 0;
      if (modelModify === "add") {
        const res = await DepartmentApi.create(params);
        if (res.status !== "0") return;
        list();
        form.resetFields();
        setIsModalOpen(false);
        message.success("创建成功");
      } else {
        params.id = editId;
        params.type = deptType;
        const res = await DepartmentApi.update(params);
        if (res.status !== "0") return;
        list();
        form.resetFields();
        setIsModalOpen(false);
        message.success("修改成功");
      }
    });
  };

  // 删除部门
  const delMenu = (id) => {
    Modal.confirm({
      title: "删除部门",
      icon: <ExclamationCircleOutlined />,
      content: "此操作将永久删除部门, 是否继续?",
      okText: "确认",
      cancelText: "取消",
      onOk: async () => {
        const res = await DepartmentApi.delete({ id });
        if (res.status !== "0") return;
        message.success("删除成功");
        list();
      },
    });
  };

  const list = () => {
    DepartmentApi.getDeptForTree({}).then((res) => {
      if (res.status == 0) {
        const handleData = getTreeData(res.data);
        setResourceTree(handleData);
        setTreeData([
          {
            title: "主部门",
            value: 0,
            children: handleData,
          },
        ]);
        setLoading(false);
      }
    });
  };

  const resetForm = () => {
    form.resetFields();
    setIsModalOpen(false);
  };

  const columns = [
    {
      title: "部门名称",
      dataIndex: "name",
      width: 300,
      key: "name",
    },
    {
      title: "机构类型",
      width: 250,
      dataIndex: "type",
      key: "type",
      render: (_t) => typeName[_t - 1],
    },
    {
      title: "备注",
      dataIndex: "remark",
      width: 60,
      key: "remark",
      render: (_t) => (_t ? _t : "-"),
    },
    {
      title: "操作",
      key: "action",
      width: 300,
      fixed: "right",
      align: "center",
      render: (record) => {
        return (
          <Space size="middle">
            <Tag
              onClick={() => showModel("add", { id: record.id })}
              color="#87d068"
            >
              新增
            </Tag>
            <Tag onClick={() => showModel("edit", record)} color="#2db7f5">
              编辑
            </Tag>
            <Tag onClick={() => lookPerson(record.id)} color="#2db7f5">
              部门负责人
            </Tag>
            <Tag onClick={() => delMenu(record.id)} color="#f50">
              删除
            </Tag>
          </Space>
        );
      },
    },
  ];

  const deptPersonColumns = [
    {
      title: "负责人姓名",
      dataIndex: "realName",
      width: 300,
      key: "realName",
    },
    {
      title: "账户",
      width: 250,
      dataIndex: "name",
      key: "name",
    },
    {
      title: "操作",
      key: "action",
      width: 300,
      fixed: "right",
      align: "center",
      render: (record) => {
        return (
          <Space size="middle">
            <Tag
              onClick={() => delPerson(record.deptId, record.id)}
              color="#f50"
            >
              删除
            </Tag>
          </Space>
        );
      },
    },
  ];

  return (
    <div className="menu-container">
      <Button type="primary" onClick={() => showModel("add")}>
        新增
      </Button>
      <div className="menu-table">
        <Table
          columns={columns}
          rowKey={(record) => record.id}
          dataSource={resourceTree}
          pagination={false}
          loading={loading}
        />
      </div>

      {/* 新增弹出层 */}
      <Modal
        title={modelModify == "add" ? "添加部门" : "编辑部门"}
        open={isModalOpen}
        onOk={submiteForm}
        onCancel={resetForm}
      >
        <Form {...layout} form={form} autoComplete="off">
          <Form.Item name="pid" label="上级部门" initialValue={0}>
            <TreeSelect
              showSearch
              style={{
                width: "100%",
              }}
              dropdownStyle={{
                maxHeight: 400,
                overflow: "auto",
              }}
              placeholder="请选择上级部门"
              allowClear
              treeData={treeData}
            />
          </Form.Item>
          <Form.Item
            name="name"
            label="部门名称"
            rules={[
              {
                required: true,
                message: "请输入部门名称",
              },
            ]}
          >
            <Input placeholder="请输入部门名称" />
          </Form.Item>
          <Form.Item name="remark" label="备注">
            <Input placeholder="请输入备注" />
          </Form.Item>
        </Form>
      </Modal>
      {/* /新增弹出层 */}

      {/* 部门负责人弹窗 */}
      <Modal
        title="部门负责人管理"
        open={personModal}
        width={800}
        onOk={() => setPersonModal(false)}
        onCancel={() => setPersonModal(false)}
      >
        <div className="deptPerson-container">
          <div className="deptPerson-title">
            <Button
              onClick={() => getDeptChildPerson()}
              type="primary"
              size="mini"
            >
              新增
            </Button>
          </div>
          <div className="deptPerson-bd">
            <Table
              columns={deptPersonColumns}
              rowKey={(record) => record.id}
              dataSource={personList}
              pagination={false}
              loading={deptPersonLoading}
            />
          </div>
        </div>
      </Modal>
      {/* /部门负责人弹窗 */}
      <Modal
        title="新增部门负责人"
        open={addPersonModal}
        onCancel={() => (setAddPersonModal(false), setPerson(""))}
        onOk={() => addDeptPerson()}
      >
        <Select
          style={{
            width: 300,
          }}
          placeholder="请选择部门负责人"
          onChange={(e) => setPerson(e)}
          value={person}
        >
          {deptChildList.length > 0 &&
            deptChildList.map((item) => {
              return (
                <Select.Option value={item.id} key={item.id}>
                  {item.realName}
                </Select.Option>
              );
            })}
        </Select>
      </Modal>
    </div>
  );
};

export default DepartMent;
